import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"

// Define the Yup validation schema
const validationSchema = yup.object({
    userName: yup.string().required("Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    password: yup.string().required("Password is required").min(8, "Password must be at least 8 characters"),
    confirmPassword: yup.string().required("Confirm Password is required").oneOf([yup.ref("password")], "Passwords must match")
    //, age: yup.number().min(18, "You must be at least 18").required("Age is required").typeError("Age must be a number"),
}).required()

export default function Register() {
    const [loading, setLoading] = useState('');
    const navigate = useNavigate();

    // Initialize React Hook Form with the Yup resolver
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    })

    const onSubmit = async (data) => {
        try {
            setLoading('loading');
            const options = {
                method: 'POST',
                headers: {
                    //"Content-Type": "application/x-www-form-urlencoded"
                    'Content-Type': 'application/json'
                },
                //body: new URLSearchParams(params).toString()
                body: JSON.stringify(data)
            };
            const response = await fetch('api/auth/Register', options);
            const message = await response.text();
            alert(message + '\nYou need to login to access protected pages');
            //navigate to login page after successful registration
            navigate('/login');
        } catch (err) {
            console.error('Registration failed:', err);
        } finally {
            setLoading('');
        }
    };

    return (
        <>
            <h3>Create a new account</h3>
            <div className={`row ${loading}`}>
                <div className="col-md-6 col-md-offset-6" >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div asp-validation-summary="ModelOnly" className="text-danger"></div>
                        <div className="form-floating mb-2">
                            <input {...register("userName")} className="form-control" autocomplete="off" aria-required="true" />
                            <label for="userName" className="form-label">User Name</label>
                            <div>&nbsp; {errors.userName && <span className="text-danger">{errors.userName.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("email")} className="form-control" autocomplete="on" aria-required="true" />
                            <label for="email" className="form-label">Email</label>
                            <div>&nbsp; {errors.email && <span className="text-danger">{errors.email.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("password")} className="form-control" type="password" autocomplete="new-password" aria-required="true" />
                            <label for="password" className="form-label">Password</label>
                            <div>&nbsp; {errors.password && <span className="text-danger">{errors.password.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("confirmPassword")} className="form-control" type="password" autocomplete="new-password" aria-required="true" />
                            <label for="confirmPassword" className="form-label">Confirm Password</label>
                            <div>&nbsp; {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword.message}</span>}</div>
                        </div>
                        <button type="submit" className="w-100 btn btn-lg btn-primary">Register</button>
                    </form>
                    {loading && <div className='overlay'></div>}
                </div>
            </div>
        </>
    );
}